import React from "react";
import { Outlet } from "react-router-dom";
//
import { StyledBox, StyledContainer } from "./style";

const Main = (props) => {
  const { children } = props;

  return (
    <StyledBox>
      <StyledContainer>
        {children}
        <Outlet />
      </StyledContainer>
    </StyledBox>
  );
};

export default Main;
